import { MentionOptions } from '@tiptap/extension-mention';

export const customMentionConfig: Partial<MentionOptions> = {
    renderLabel: ({ node }) => `[${node.attrs.placeholderName}]`,
};
